import React, { useEffect, useRef, useState } from 'react';
import MotionWrapper from '@components/wrapper/MotionWrapper';
import styled from 'styled-components';
import { IstoreCommon } from '@typings/store/storeCommon.interface';
import { Ihashtag } from '@typings/common/hashtag.interface';
import PageLayout from '@app/layouts/pageLayout/PageLayout';
import NPCSec from '../NPC/NPCSec';
import StoreItemList from '../Detail/StoreItemList';
import StoreControlSec from '../component/StoreControlSec';
import LuckyDrawSlider from '../LuckyDraw/LuckyDrawSlider';
import { cardLineStyle } from '@styles/common/Card';
import { scrollbarStyle } from '@styles/variants/scrollbar';

type Props = {
  setData: IstoreCommon | null | undefined;
  visibleHashtagList: Ihashtag[];
};

function DefaultLayout({ setData, visibleHashtagList }: Props) {

  return (
    <MotionWrapper>
      <PageLayout>
        <StoreControlWrapper>
          <StoreControlSec />
        </StoreControlWrapper>
        <Container>
          {setData?.logoImgURL && (
            <LogoSec>
              <img src={setData?.logoImgURL} alt="logo" />
            </LogoSec>
          )}
          <NPCSec />

          <Side>
            <LuckyDrawSlider />
            <StoreItemSec>
              <StoreItemList />
            </StoreItemSec>
          </Side>
        </Container>
      </PageLayout>
    </MotionWrapper>
  );
}

export default DefaultLayout;



const Container = styled.div`
  width: 100%;
  height: 90dvh;
  overflow: hidden;

  display: grid;
  grid-template-columns: 1fr 1.5fr;
  align-items: center;
  position: relative;

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    height: auto;
    overflow: visible;
  }
`;


const Side = styled.div`
  width: 100%;
  height: 100%;
  gap: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

  @media (max-width: 480px) {
    height: auto;
    overflow: visible;
  }
`;

const StoreItemSec = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px;
  ${cardLineStyle}
  
  /* 내부 스크롤을 위한 설정 */
  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  @media (max-width: 480px) {
    overflow: visible;
    height: auto;

    > div {
      overflow: visible;
      height: auto;
    }
  }
`;

const LogoSec = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;

  @media (max-width: 480px) {
    position: relative;
    img {
      width: 100%;
    }
  }
`;

const StoreControlWrapper = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`;
